import React, { Component } from 'react';
import { Pagination } from "react-bootstrap";
import Container from '../../components/Container';
import Heading from '../../components/Heading';
import Form from './components/Form';
import Table from './components/Table';
import API from '../../services/API';
import {PAGE_LIMIT} from "../../data/config";

class AdKernel extends Component {
    constructor() {
        super();

        this.state = {
            feedValues: [],
            subidValues: [],
            report: [],
            reportTotal: {},
            pagesTotal: 0,
            activePage: 1,
            sortParam: null,
            sortOrder: 1,
            isLoading: false
        };

        this.handleFieldChange = this.handleFieldChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleSort = this.handleSort.bind(this);
        this.handlePageSelect = this.handlePageSelect.bind(this);
    }

    componentWillUpdate(nextProps, nextState) {
        const { report, sortParam, sortOrder } = nextState;

        if(this.state.sortParam != sortParam || this.state.sortOrder != sortOrder) {
            this.sortReport(report, sortParam, sortOrder);

            this.setState({ report, activePage: 1 });
        }
    }

    sortReport(report, sortParam, sortOrder) {
        report.sort((objA, objB) => {
            if(objA[sortParam] > objB[sortParam]) return 1 * sortOrder;
            else if(objA[sortParam] < objB[sortParam]) return -1 * sortOrder;

            return 0;
        });
    }

    handleFieldChange(event) {
        const { value, name } = event.target;

        this.setState({ [name]: value });
    }

    handleSubmit(type, filters) {
        this.setState({ isLoading: true });

        if(type === 'feed') return this.loadFeeds(filters);
        if(type === 'subid') return this.loadSubid(filters);

        API.AdKernel.get(filters, type).then(({ report, total }) => {
            const pagesTotal = Math.ceil(report.length / PAGE_LIMIT);

            this.setState({ report, reportTotal: total, pagesTotal, activePage: 1, isLoading: false })
        });
    }

    loadFeeds(filters) {
        API.AdKernel.get(filters, 'feed').then(({ report, total }) => {
            const feedValues = report.map(({ feed }) => feed);
            const pagesTotal = Math.ceil(report.length / PAGE_LIMIT);

            this.setState({ feedValues, report, reportTotal: total, pagesTotal, activePage: 1, isLoading: false })
        });
    }

    loadSubid(filters) {
        API.AdKernel.get(filters, 'subid')
            .then(subid => this.setState({ subidValues: subid, isLoading: false }));
    }

    handleSort(param) {
        const { sortParam, sortOrder } = this.state;

        if(sortParam === null) this.setState({ sortParam: param });
        else if(param === sortParam) this.setState({ sortOrder: sortOrder * -1 });
        else this.setState({ sortParam: param, sortOrder: 1 });
    }

    handlePageSelect(activePage) {
        this.setState({ activePage });
    }

    getTable() {
        let { report, reportTotal, activePage } = this.state;

        if(report.length) {
            const pageStart = ( activePage - 1 ) * PAGE_LIMIT;
            const pageEnd = activePage * PAGE_LIMIT;
            report = report.slice(pageStart, pageEnd);

            return <Table report={report} total={reportTotal} onSortChange={this.handleSort}/>;
        }

        return <p>No Data</p>
    }

    render() {
        const { isLoading, feedValues, subidValues } = this.state;

        return (
            <Container loading={isLoading}>
                <Heading title="AdKernel"/>
                <Form onSubmit={this.handleSubmit} feedValues={feedValues} subidValues={subidValues}/>

                {this.getTable()}

                <Pagination
                    items={this.state.pagesTotal}
                    maxButtons={20}
                    onSelect={this.handlePageSelect}
                    activePage={this.state.activePage}
                />
            </Container>
        );
    }
}

export default AdKernel;


// WEBPACK FOOTER //
// ./src/scenes/AdKernel/index.js